<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { getAnalytics } from '@firebase/analytics'
import { initializeApp } from '@firebase/app'

import { globalConfig } from "@/config";
import $config from "@/helpers/config/index";
import checkUTM from "@/helpers/utils/checkUTM";

let domain = ``;
if ($config.key === "prod") {
  domain =
    $config.project === "profy" ? "domain=getprofy.de;" : "domain=hilfy.at;";
}

export default {
  created() {
    document.cookie = `active=true;path=/;${domain}`;
    checkUTM();
    if (!globalConfig.firebaseConfig || !globalConfig.firebaseConfig?.apiKey) return

    const app = initializeApp(globalConfig.firebaseConfig)
    const analytics = getAnalytics(app)
  },
};

window.onbeforeunload = function() {
  document.cookie = `active=null;path=/;${domain}`;
};
</script>

<style lang="scss">
#app {
  color: #2c3e50;
  width: 100%;
}
</style>

<style>
.vue-tel-input {
  border: none !important;
  background-color: #f2f2f2;
  border-radius: 10px !important;
}

.vti__dropdown {
  border-radius: 10px !important;
}

.vti__dropdown-list {
  max-width: 285px;
  width: 100%;
}
</style>
